module.exports = __webpack_public_path__ + "img/smartphone-payment.bff9ddae.png";